import { Component, OnInit, OnChanges, SimpleChanges, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';

import { FiltersService } from '../../services/filters.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { UntypedFormControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-item-filters',
	templateUrl: './item-filters.component.html',
	styleUrls: ['./item-filters.component.scss'],
})
export class ItemFiltersComponent implements OnInit, OnChanges {
	@Input() customer;
	/** Horizontal toolbar row (salesman beauty order entry) vs left sidebar */
	@Input() inlineToolbar = false;
	@Input() activeFilters: any[] = [];
	@Output() filtersSelected = new EventEmitter<any[]>();
	@Output() clearAll = new EventEmitter<void>();
	@Output() searchRequested = new EventEmitter<void>();
	@ViewChild('productlineFilter') prodlineFilterRef: ElementRef;

	filters: any[];
	filterDefsCache: any[] = [];
	config: any = false;
	selected_filters: { [filterId: number]: { filter_id: number; value: any } } = {};
	selected_checks: { [filterId: number]: { value: any }[] } = {};
	issalesman = false;
	filteredOptions: any = [];
	linesearchref = new UntypedFormControl('');
	productLineCheckBoxFilter: any = false;
	prods: any = [];
	client: any = false;

	constructor(
		private modalService: NgbModal,
		private globalSearchService: GlobalSearchService,
		private filtersService: FiltersService
	) {
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
			this.client = r.env.client;
			this.globalSearchService.user.subscribe(u => {
				if (u.user.issalesman) {
					this.issalesman = true;
				}
			});
		});
	}

	ngOnInit(): void {
		this.filtersService.getFilters().subscribe((results: any) => {
			this.filterDefsCache = this.cloneFilters(results || []);
			this.filters = this.cloneFilters(results || []);
			this.applyActiveFiltersToUi();
		});

		this.linesearchref.valueChanges.subscribe((newv) => {
			this.filterProductLines(newv);
		});
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.activeFilters && this.filters && this.filters.length) {
			this.applyActiveFiltersToUi();
		}
	}

	private cloneFilters(filters: any[]): any[] {
		return JSON.parse(JSON.stringify(filters || []));
	}

	private applyActiveFiltersToUi(): void {
		if (!this.filters || !this.filters.length) return;

		this.selected_filters = {};
		this.selected_checks = {};
		this.prods = [];

		(this.activeFilters || []).forEach((f: any) => {
			if (!f || f.filter_id === undefined || f.filter_id === null) return;
			const val = f.value;
			if (val === undefined || val === null || val === '' || val === 'reset') return;
			if (Array.isArray(val) && val.length === 0) return;
			this.selected_filters[f.filter_id] = { filter_id: f.filter_id, value: val };
		});

		this.filters.forEach((filter: any) => {
			const selected = this.selected_filters[filter.filter_id];
			const selectedValue = selected ? selected.value : undefined;

			if (filter.input_type === 'select') {
				filter.default_value = selectedValue ?? (this.issalesman ? 'reset' : null);
				return;
			}

			if (filter.input_type === 'multis') {
				filter.default_value = Array.isArray(selectedValue)
					? selectedValue.map((entry: any) => entry?.value ?? entry)
					: [];
				return;
			}

			if (filter.input_type === 'checkbox') {
				const selectedEntries = Array.isArray(selectedValue) ? selectedValue : [];
				const selectedSet = new Set(selectedEntries.map((e: any) => String(e?.value ?? e)));

				this.selected_checks[filter.filter_id] = selectedEntries.map((e: any) => ({ value: e?.value ?? e }));

				(filter.options || []).forEach((opt: any) => {
					opt.checked = selectedSet.has(String(opt.value));
				});
				if (filter.optionsfull) {
					filter.optionsfull.forEach((opt: any) => {
						opt.checked = selectedSet.has(String(opt.value));
					});
				}
				return;
			}

			if (filter.input_type === 'modal' && filter.name === 'Product Line') {
				const selectedEntries = Array.isArray(selectedValue) ? selectedValue : [];
				this.prods = selectedEntries.map((e: any) => ({ line_field: e?.value ?? e }));
			}
		});
	}

	private emitCurrentFilters(): void {
		const result: { filter_id: number; value: any }[] = [];
		Object.values(this.selected_filters).forEach((f: any) => {
			if (!f || f.filter_id === undefined || f.filter_id === null) return;
			const val = f.value;
			if (val === undefined || val === null || val === '' || val === 'reset') return;
			if (Array.isArray(val) && val.length === 0) return;
			result.push({ filter_id: f.filter_id, value: val });
		});
		this.filtersSelected.emit(result);
	}

	requestSearch(): void {
		this.searchRequested.emit();
	}

	updateChecks(event: any, filter_id: any): void {
		if (!this.selected_checks[filter_id]) {
			this.selected_checks[filter_id] = [];
		}

		const data = { value: event.source.value };

		if (event.checked) {
			this.selected_checks[filter_id].push(data);
		} else {
			this.selected_checks[filter_id] = this.selected_checks[filter_id].filter(
				s => s.value !== event.source.value
			);
		}

		if (this.selected_checks[filter_id].length) {
			this.selected_filters[filter_id] = { filter_id, value: this.selected_checks[filter_id] };
		} else {
			delete this.selected_filters[filter_id];
		}

		this.emitCurrentFilters();
	}

	searchOptions(options: any[], searchTerm: string): void {
		const lowerCaseTerm = searchTerm.toLowerCase();
		this.filteredOptions = options.filter(option =>
			option.label.toLowerCase().includes(lowerCaseTerm)
		);
	}

	updateSearchSelect(event: any, filter_id: any): void {
		if (event.value !== 'reset' && event.value !== null && event.value !== undefined) {
			this.selected_filters[filter_id] = { filter_id, value: event.value };
		} else {
			delete this.selected_filters[filter_id];
		}
		this.emitCurrentFilters();
	}

	resetFilters(): void {
		this.filters = this.cloneFilters(this.filterDefsCache);
		this.selected_filters = {};
		this.selected_checks = {};
		this.prods = [];
		this.linesearchref.setValue('', { emitEvent: false });
		this.clearAll.emit();
	}

	resetProdlines(): void {
		this.linesearchref.setValue('');
		this.selected_checks[this.productLineCheckBoxFilter] = [];
		delete this.selected_filters[this.productLineCheckBoxFilter];

		this.filters.forEach((filter: any) => {
			if (filter.filter_id === this.productLineCheckBoxFilter) {
				(filter.optionsfull || []).forEach((opt: any) => { opt.checked = false; });
				(filter.options || []).forEach((opt: any) => { opt.checked = false; });
			}
		});

		this.emitCurrentFilters();
	}

	updateProductLinesFromModal($event: any): void {
		this.prods = $event;
	}

	openProductLines(): void {
		const filterDef = this.filters.find(
			(i: any) => i.input_type === 'modal' && i.name === 'Product Line'
		);
		if (!filterDef) return;
		const filterindex = filterDef.filter_id;

		this.modalService.open(this.prodlineFilterRef, { ariaLabelledBy: 'modal-basic-title', size: 'xl' }).result.then(
			() => {},
			() => {
				if (this.prods.length) {
					this.selected_checks[filterindex] = [];
					delete this.selected_filters[filterindex];
					this.prods.forEach((prodline: any) => {
						this.updateChecks({ source: { value: prodline.line_field }, checked: true }, filterindex);
					});
				} else {
					this.selected_checks[filterindex] = [];
					delete this.selected_filters[filterindex];
					this.emitCurrentFilters();
				}
			}
		);
	}

	filterProductLines(input: string): void {
		const filtername = this.client === 'aaprod' ? 'Manufacturer' : 'Product Line';

		this.filters.forEach((f: any) => {
			if (f.name === filtername && f.input_type === 'checkbox') {
				this.productLineCheckBoxFilter = f.filter_id;
				let batchadd = false;

				if (!f.optionsfull) {
					f['optionsfull'] = f['options'];
				}

				if (input.charAt(input.length - 1) === '*' && f.options.length) {
					f.optionsfull.forEach((filter: any) => {
						if (f.options.indexOf(filter) > -1) {
							let checked = true;
							if (filter.checked === '1' || filter.checked === true) {
								checked = false;
							}
							f.options[f.options.indexOf(filter)]['checked'] = checked;
							filter['checked'] = checked;
							this.updateChecks({ source: { value: filter.value }, checked: filter['checked'] }, f.filter_id);
						}
					});
					batchadd = true;
				}

				if (!batchadd) {
					if (input === '') {
						f.options = f.optionsfull;
					} else {
						f.options = f['optionsfull'].filter((i: any) => {
							return (i.label + '+' + i.value).toUpperCase().includes(input.toUpperCase());
						});
					}
				}
			}
		});
	}
}
